module.exports = __webpack_public_path__ + "static/media/3.13.a1fe2599.png";